import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { NgWord } from '~/types/ng-word'
import { NgWordDeleteDialog } from './components/ng-word-delete-dialog'
import { NgWordDetailDialog } from './components/ng-word-detail-dialog'
import { NgWordFormDialog } from './components/ng-word-form-dialog'
import { NgWordsList } from './components/ng-words-list'

export function NgWordsPage() {
  const { t } = useTranslation()
  const [selectedItem, setSelectedItem] = useState<NgWord | null>(null)
  const [editingItem, setEditingItem] = useState<NgWord | null>(null)
  const [deletingItem, setDeletingItem] = useState<NgWord | null>(null)

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold" id="ng-words-title">
        {t('ngWords.title')}
      </h1>
      <NgWordsList onViewDetail={setSelectedItem} />
      <NgWordDetailDialog item={selectedItem} onEdit={setEditingItem} onDelete={setDeletingItem} />
      <NgWordFormDialog editingItem={editingItem} />
      <NgWordDeleteDialog deletingItem={deletingItem} />
    </div>
  )
}
